import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white shadow-xl rounded-lg p-8 max-w-md w-full" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-2xl font-bold text-foreground mb-6 text-center" }, "Login", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "email",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Enter your email",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "password",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Password", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Enter your password",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error.message), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "w-full bg-primary hover:bg-primary/90 text-primary-foreground font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out mb-4",
        disabled: _ctx.loading
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Logging in..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "Login"))
      ], 8, _hoisted_5),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchToRegister && _ctx.switchToRegister(...args))),
          class: "text-primary hover:text-primary/80 text-sm font-medium"
        }, " Don't have an account? Register ")
      ])
    ], 32)
  ]))
}